/**
 * Vue filter to round the decimal to the given place.
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */

import Vue from 'vue'

Vue.filter('round', (value: any, decimals: number) => {
  if (!value) {
    value = 0
  }

  if (!decimals) {
    decimals = 0
  }

  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
  return value
})
